import React from 'react';

import { Hero } from "../../components/header/header";

const VideoPage = () => (
    <>
      <Hero
        title={"Cotmarsh Tannery CIC"}
        subtitle={"Traditional leather micro-tannery"}
      ></Hero>
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      <div className="main_bg">
        <div className="wrap">
          <div className="main">
    <h1>Video Stream</h1>
    {/* <video
      width="720"
      controls
      style={{ maxWidth: '100%' }}
      src="/videos/setter-move.mov"
    >
      Sorry, your browser doesn't support embedded videos.
    </video> */}
          </div>
        </div>
      </div>
  </div>
    </>
);
export default VideoPage;